module.exports = __webpack_public_path__ + "static/media/gallery_03.5132811f.png";